import React, {useEffect} from 'react';
import Wrapper from "../components/Wrapper.js";
import {useParams, useNavigate} from "react-router-dom";
import Api from "../Api.js";
import Loader from "../components/BlueButton/Loader.js";
import {Col, Row} from "react-bootstrap";
import {word} from "../word.js";
import IconButtonCont from "../components/Survey/IconButtonCont.js";

import SurveyFiles from "../components/Survey/SurveyFiles.js";
import {TextField} from "@mui/material";
import moment from "moment";
import AddAndEditSurvey from "../components/Survey/AddAndEditSurvey.js";
import BlueButton from "../components/BlueButton/BlueButton.js";
import ErrorToast from "../components/BlueButton/ErrorToast.js";
import SurveyFinish from "../components/Survey/SurveyFinish.js";
import MessageInput from "../components/Survey/MessageInput.js";

function SurveySingle(props) {
    const {id} = useParams()
    const [data, setData] = React.useState(null);
    const [edit, setEdit] = React.useState(null);
    const [finish, setFinish] = React.useState(null);
    const [visibleFile, setVisibleFile] = React.useState(false);
    const [visibleMessage, setVisibleMessage] = React.useState(false);
    const navigate = useNavigate()
    const [loading, setLoading] = React.useState(false);
    const getData = async () => {
        if (id) {
            try {
                const {data} = await Api.getSurveySingle(id);
                setData(data);
            } catch (error) {
                console.error('Error fetching survey:', error);
            }
        }
    }
    useEffect(() => {
        (async () => {
            await getData();
        })();
    }, [id])

    const handleEdit = async (data) => {
        try {
            setLoading(true);
            setEdit(null);
            if(data === "ended") {
                setFinish(id)
            }else{
                await Api.updateSurveyStatus(id, {status: data});

                await getData();

            }
            setLoading(false);
        } catch (error) {
            ErrorToast()
            console.error('Error editing survey:', error);
        }
    }
    return (
        <Wrapper>
            {!data ? (
                <div className="loaderMargin">
                    <Loader type="Oval" size={30}/>
                </div>
            ) : null}
            {data ? <div className='recommendation-page'>
                <Row>
                    <Col xs={12} sm={12}>
                        <a onClick={() => navigate(-1)} className="link-Backward-arrow">
                            <span className="icon-Backward-arrow"/>
                        </a>
                        <div className="timePicker-cont-change justify-content-end">
                            <div className="timePicker-cont">
                                <TextField
                                    id="datetime-local"
                                    label="Վերջնաժամկետ"
                                    type="datetime-local"
                                    disabled={true}
                                    value={data?.deadline || ""}
                                    InputProps={{inputProps: {min: moment(new Date()).format("YYYY-MM-DDTHH:mm")},}}
                                    sx={{width: 250}}
                                    InputLabelProps={{shrink: true}}
                                />
                            </div>

                            <div className="icons-copy-edit">
                                <div className="tool-tip-cont">
                                    <div className="tool-tip">Խմբագրել</div>
                                    <span onClick={() => setEdit(data)} className="icon-Compose"/>
                                </div>
                            </div>
                        </div>
                        <div className="accountant-name-list">
                            <span className="accountant-name-list-title">Ուղարկված է</span>
                            {data.recipients?.map((item, index) => (
                                <div key={index} className="notification-accountant-name">
                                    {item.last_name} {item.first_name}
                                    {(item.first_name.endsWith("ա") || item.first_name.endsWith("ո")) ? "յին" : "ին"},
                                </div>
                            ))}
                        </div>

                        <h1 className="recommendation-page-title">{data.title}</h1>
                        <p className="recommendation-page-description">{data.purpose}</p>
                        {data.status === "ended"?<p className="recommendation-page-description">Եզրահանգում - {data.finish}</p>:null}
                        {data.company?<p className="recommendation-page-description">Կազմակերպություն - {data.company.name}</p>:null}
                        <BlueButton
                            disabled={loading}
                            onChangeValue={() => handleEdit(data.status === "active" ? "ended" : 'active')}
                            title={loading?(
                                <Loader size={15}/>
                            ):data.status === "active" ? "Ավարտել" : "Սկսել"}/>
                        <div className='line-blue'/>
                        <span className="message-heading">{word.message}</span>
                        <IconButtonCont setVisibleFile={setVisibleFile} visibleFile={visibleFile}
                                        visibleMessage={visibleMessage} setVisibleMessage={setVisibleMessage}
                                        data={data}/>
                        <MessageInput visibleMessage={visibleMessage}/>
                    </Col>
                </Row>
                {visibleFile ? <SurveyFiles open={visibleFile} setData={getData} task={data} setOpen={setVisibleFile}
                                            show_loading={false}/> : null}
                {edit ?
                    <AddAndEditSurvey getData={getData} show={edit} isEdit={edit} onHide={() => setEdit(null)}/> : null}

                {finish? <SurveyFinish show={finish} onHide={() => setFinish(false)} getData={getData} />:null}
            </div> : null}

        </Wrapper>
    );
}

export default SurveySingle;